(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/route-result/assets/javascripts/results-draw-selector.js') >= 0) return;  svs.modules.push('/components/tipsen/route-result/assets/javascripts/results-draw-selector.js');
"use strict";

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
const _svs$ui$ReactItemsMen = svs.ui.ReactItemsMenu,
  ItemsMenu = _svs$ui$ReactItemsMen.ItemsMenu,
  LinkItem = _svs$ui$ReactItemsMen.LinkItem;
const _ReactRouterDOM = ReactRouterDOM,
  useHistory = _ReactRouterDOM.useHistory,
  useLocation = _ReactRouterDOM.useLocation;
const useBranding = svs.components.tipsen.hooks.useBranding;
const _svs$components$sport = svs.components.sport.tipsenShared,
  getDrawStateEnum = _svs$components$sport.getDrawStateEnum,
  drawStateEnums = _svs$components$sport.drawStateEnums;
const ResultsDrawSelector = _ref => {
  let draws = _ref.draws,
    selectedDraw = _ref.selectedDraw;
  const history = useHistory();
  const location = useLocation();
  const _useBranding = useBranding(),
    _useBranding2 = _slicedToArray(_useBranding, 1),
    productBranding = _useBranding2[0];
  const selectedItem = selectedDraw;
  if (!draws || draws.length <= 1) {
    return null;
  }
  return React.createElement(ItemsMenu, {
    branding: "side-nav",
    className: "side-nav-menu side-nav-menu--".concat(productBranding),
    hiddenScrollbar: true,
    useScrollFaders: true,
    useScrollHelpers: true
  }, draws.map((draw, index) => React.createElement(LinkItem, {
    badge: true,
    badgeNr: getDrawStateEnum(draw.drawStateId) === drawStateEnums.LIVE ? 'Live' : '',
    Component: "div",
    key: "".concat(draw === null || draw === void 0 ? void 0 : draw.drawNumber, "-").concat(draw === null || draw === void 0 ? void 0 : draw.productId, "-").concat(draw === null || draw === void 0 ? void 0 : draw.date),
    label: "Omg\xE5ng ".concat(index + 1),
    onClick: () => {
      history.replace("".concat(location.pathname, "?draw=").concat(draw.drawNumber, "&product=").concat(draw === null || draw === void 0 ? void 0 : draw.productId));
    },
    selected: selectedItem === "".concat(draw === null || draw === void 0 ? void 0 : draw.drawNumber, "-").concat(draw === null || draw === void 0 ? void 0 : draw.productId)
  })));
};
setGlobal('svs.components.tipsen.routeResult.ResultsDrawSelector', ResultsDrawSelector);

 })(window);